/**
 * MentorWallet — Standalone product.
 *
 * This file replaces the multi-tenant system. MentorWallet is a single
 * product with a single domain. All tenant resolution returns fixed values.
 */

export interface TenantBranding {
  primary_color?: string
  secondary_color?: string
  accent_color?: string
  logo_url?: string
  favicon_url?: string
  font_display?: string
  font_body?: string
  dark_logo_url?: string
  font_family?: string
}

export interface TenantSettings {
  default_course_slug?: string
  [key: string]: unknown
}

export interface Tenant {
  id: string
  slug: string
  name: string
  is_default: boolean
  branding: TenantBranding
  settings: TenantSettings
  custom_domain: string | null
  status?: 'active' | 'suspended' | 'archived'
}

// ── Fixed tenant ────────────────────────────────────────────
// MentorWallet is a standalone product. No multi-tenant resolution.

const MW_TENANT: Tenant = {
  id: '4195db3f-ad3c-4c06-be8c-089e8410e345',
  slug: 'mentor-wallet',
  name: 'MentorWallet',
  is_default: true,
  branding: {
    primary_color: '#2563EB',
    accent_color: '#131830',
    font_display: 'Bricolage Grotesque',
    font_body: 'Instrument Sans',
  },
  custom_domain: null,
  status: 'active' as const,
  settings: {
    default_course_slug: 'mentor-wallet',
  },
}

/**
 * Always returns 'mentor-wallet'. No subdomain detection needed.
 */
export function resolveTenantSlug(): string {
  return 'mentor-wallet'
}

/**
 * Returns the fixed MentorWallet tenant. No DB query needed.
 */
export async function loadTenant(_slug?: string): Promise<Tenant> {
  return MW_TENANT
}

/**
 * Returns the fixed tenant synchronously.
 */
export function getTenantSync(): Tenant {
  return MW_TENANT
}

/**
 * No-op. Single tenant, no bootstrap needed.
 */
export async function bootstrapUserInTenant(_userId: string): Promise<void> {
  // No-op for standalone product
}

/**
 * Compatibility stubs — these existed in the multi-tenant version.
 * Kept as no-ops for code that still references them.
 */
export const DEFAULT_TENANT_SLUG = 'mentor-wallet'

export function looksLikeSlug(_s: string): boolean {
  return false
}
